import type { JSX } from 'react';
import { MoreHorizontal, Pencil, KeyRound, UserX, UserCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { SuperAdmin } from '../types/super-admin.types';

interface SuperAdminActionsMenuProps {
  superAdmin: SuperAdmin;
  onEdit: (admin: SuperAdmin) => void;
  isDisabled: boolean;
  onResetPassword: () => void;
  onDeactivate: () => void;
  onActivate: () => void;
}

export function SuperAdminActionsMenu({
  superAdmin,
  onEdit,
  isDisabled,
  onResetPassword,
  onDeactivate,
  onActivate,
}: SuperAdminActionsMenuProps): JSX.Element {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" aria-label="Actions" disabled={isDisabled}>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onEdit(superAdmin)}>
          <Pencil className="h-4 w-4 mr-2" />
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onResetPassword}>
          <KeyRound className="h-4 w-4 mr-2" />
          Reset Password
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {superAdmin.isActive ? (
          <DropdownMenuItem variant="destructive" onClick={onDeactivate}>
            <UserX className="h-4 w-4 mr-2" />
            Deactivate
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onClick={onActivate}>
            <UserCheck className="h-4 w-4 mr-2" />
            Activate
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
